import ElForm from './Form.vue'

/* istanbul ignore next */
ElForm.install = function (app) {
  app.component(ElForm.name, ElForm)
}

export default ElForm
